import { IConfigurationResponse } from "@/apps/merchant3/models/IConfigurationResponse";

const mutations = {
  SET_CONFIGURATIONS: (
    state: IConfigurationResponse,
    payload: IConfigurationResponse
  ): void => {
    Object.keys(payload).forEach((key) => (state[key] = payload[key]));
  },
};

export default mutations;
